/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import {
  Slide,
  Grid,
  FormControl,
  Input,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  Typography,
  IconButton,
  Box,
  useMediaQuery,
  DialogContent,
  DialogActions,
  Paper,
  Zoom,
} from "@mui/material";
import RegistroPacientes from "../RegistroPacientes";
import Close from "@mui/icons-material/CloseOutlined";
import firebase from "../../services/firebase";
import "./login.css";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import env from "@beam-australia/react-env";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { setToken, setGlobalUser } from "../../redux/session";
import { app, socketApp, socket } from "../../services/index"; // importa también socketApp y socket
import { updateCatalogs } from "../../redux/catalogs";
import { catalogs } from "../../repositories";
import defaultCatalogs from "../../constants/defaultCatalogs.json";
import { useTheme } from "@mui/styles";
import Lottie from "react-lottie-player";
import lottieJson from "./loading.json";
import lottieJsonPortlad from "./loading-portland.json";
import EditableModel from "../EditableModel.js";
import CatalogsIconButton from "../customForms/CatalogsIconButton";
import { usuarios } from "../../constants/models";
const initialState = {
  registroDisplay: false,
  loading: false,
  result: null,
  optionsModal: false,
  loginOk: false,
  notification: null,
};
const API_BASE_URL =
  env("REACT_APP_API_URL") ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:3030";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const HS =
  "1103760000003C0000003C0000000000000000000000000000000000000000000000000000177003E803E803E803E800000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000007294";

function Login(props) {
  const user = useSelector((state) => state.session.globalUser);
  const [intro, setIntro] = useState(false);
  const [open, setopen] = useState(props.open);
  const dispatch = useDispatch();
  const [play, setPlay] = useState(false);
  const [state, setState] = useState(initialState);
  const [inviteState, setInviteState] = useState({
    open: false,
    loading: false,
    saving: false,
    idClient: "",
    token: "",
    email: "",
    nombre: "",
    idInstitucion: "",
    institutionName: "",
    institutionLogo: "",
    password: "",
    passwordConfirm: "",
    error: "",
    success: "",
  });
  const theme = useTheme();
  const history = useHistory();
  // console.log('history', history.location.pathname);
  useEffect(() => {
    setopen(props.open);
  }, [props.open]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search || "");
    const mode = (params.get("mode") || "").toLowerCase();
    const idClient = params.get("id_client") || "";
    const token = params.get("token") || "";
    if (mode !== "register" || !idClient || !token) return;

    let cancelled = false;
    setInviteState((prev) => ({
      ...prev,
      open: true,
      loading: true,
      idClient,
      token,
      error: "",
      success: "",
    }));

    fetch(
      `${API_BASE_URL}/api/client-invite/resolve?id_client=${encodeURIComponent(idClient)}&token=${encodeURIComponent(token)}`,
      {
        method: "GET",
      },
    )
      .then(async (res) => {
        const json = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(
            json?.message ||
              `No fue posible validar la invitación (HTTP ${res.status})`,
          );
        }
        if (cancelled) return;
        const cliente = json?.cliente || {};
        const nombre = [
          cliente?.vc_nombre,
          cliente?.vc_paterno,
          cliente?.vc_materno,
        ]
          .filter(Boolean)
          .join(" ");
        setInviteState((prev) => ({
          ...prev,
          loading: false,
          email: cliente?.vc_correo || "",
          nombre: nombre || "Cliente",
          idInstitucion: json?.id_institucion || "",
          institutionName: json?.institucion?.vc_nombre || "",
          institutionLogo: json?.institucion?.vc_logo || "",
        }));
      })
      .catch((error) => {
        if (cancelled) return;
        setInviteState((prev) => ({
          ...prev,
          loading: false,
          error: error?.message || "No fue posible validar la invitación.",
        }));
      });

    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {}, []);
  function renderInputs() {
    const fields = getInputs();
    const regExp = new RegExp(
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    );
    const valEmail = regExp.test(fields.email);
    return (
      <Grid padding={2}>
        <FormControl fullWidth>
          <Input
            key={fields.email.fieldid}
            id={fields.email.fieldid}
            field={fields.email.key}
            name={fields.email.fieldid}
            readOnly={fields.email.readOnly || false}
            label={fields.email.vc_name}
            type={fields.email.type}
            fullWidth
            defaultValue={""}
            disableUnderline
            placeholder={fields.email.name}
            inputProps={{
              placeholder: fields.email.name,
              style: {
                padding: "12px 18px",
                borderRadius: 15,
                height: 25,
              },
            }}
            errormessage={!valEmail ? "E-mail no valido" : ""}
          />
        </FormControl>
        <FormControl fullWidth>
          <Input
            key={fields.password.fieldid}
            id={fields.password.fieldid}
            field={fields.password.key}
            name={fields.password.fieldid}
            readOnly={fields.password.readOnly || false}
            label={fields.password.vc_name}
            type={fields.password.type}
            fullWidth
            defaultValue={""}
            margin="dense"
            disableUnderline
            placeholder={fields.password.name}
            inputProps={{
              placeholder: fields.password.name,

              style: {
              padding: "12px 18px",
                borderRadius: 15,
                height: 25,
              },
            }}
            style={{ marginTop: 16, minWidth: 300 }}
          />
          <Typography
            color="primary"
            component={"a"}
            marginTop={1}
            onClick={recuperarCuenta}
          >
            {"¿Olvidaste tu contraseña?"}
          </Typography>
          <div className="acciones" style={{ margin: "16px 0px" }}>
            <Button fullWidth variant="outlined" onClick={onButtonClick}>
              {"Iniciar sesión"}
            </Button>
          </div>
        </FormControl>
        <Grid
          item
          xs
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <CatalogsIconButton
            variant="text"
            title={"Crear usuario"}
            mode="title"
            model={usuarios}
          />
          <Button
            color="primary"
            component={"a"}
            onClick={() => {
              setState({ ...state, registroDisplay: true });
            }}
          >
            {"Comunicate con Lukai"}
          </Button>
        </Grid>
        <Box p={1} position={"absolute"} bottom={0} right={0}>
          <Typography
            fontSize={10}
            style={{ color: "gray", textAlign: "right" }}
          >
            {`Version: ${"4.1.1" || process.env.REACT_APP_VERSION}`}
          </Typography>
        </Box>
      </Grid>
    );
  }

  function renderUsuarioRegistro() {
    return (
      <RegistroPacientes
        registroDisplay={state.registroDisplay}
        backButton={() => {
          setState({ ...state, registroDisplay: false });
        }}
      />
    );
  }

  function recuperarCuenta() {
    let formData = {};
    Object.values(getInputs()).map((field, index) => {
      const renderField = document.getElementById(field.key);
      if (renderField.value) {
        formData[field.key] = renderField.value;
      }
    });
    const regExp = new RegExp(
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    );
    const valEmail = regExp.test((formData.emailLogin || "").toLowerCase());
    // auth().sendPasswordResetEmail(formData.email,{url:`https://app.thin-k.mx/#/restablecer?email=${formData.email}`}).catch(function (error) {

    // 	console.log('respuesta a firebase', e)
    // })

    if (formData.emailLogin && valEmail) {
      const body = {
        email: formData.emailLogin,
      };
      setState({ ...state, result: null, loading: true });
      window.$.ajax({
        url: `${env("REACT_APP_API_URL")}/app/resetPasswordMail/${body.email}`,
        data: body,
        method: "GET",
      })
        .then((data, status, xhr, error) => {
          if (data.message) {
            setState({
              ...state,
              result: null,
              optionsModal: false,
              loading: false,
              notification: { title: data.message, message: "" },
            });
          }
        })
        .fail((data, status, xhr, error) => {
          setState({
            ...state,
            result: null,
            optionsModal: false,
            loading: false,
            notification: {
              title: "!Ups¡",
              message: error || "comprueba tu conexión a internet",
            },
          });
        });
    } else {
      setState({
        ...state,
        result: null,
        optionsModal: false,
        loading: false,
        notification: { title: "Ingresa un E-Mail valido." },
      });
    }
  }
  function renderUsuarioRecuperacion() {
    return (
      <Dialog
        open={!!(state.email && state.vc_token && state.recoveryModal)}
        size="mini"
        basic
      >
        {/* <RecuperacionUsuarioModal
					email={state.email}
					vc_token={state.vc_token}
					backButton={() => {
						setState({...state, registroDisplay: false, recoveryModal: false });
					}}
				/> */}
      </Dialog>
    );
  }

  // ----------------------
  // ------  methods ------
  // ----------------------

  const loginService = async (formData) => {
    try {
      if (app.authentication?.authenticated) await app.logout();

      const response = await app.authenticate({
        strategy: "local",
        email: formData.email,
        password: formData.password,
      });

      setState({ ...state, result: null, loading: false });

      const authData = await app.get("authentication"); // aquí viene accessToken + usuario
      const token = authData?.accessToken;

      // ✅ Guardas user y token como ya lo haces
      const res = await app.service("users-roles").find({
        query: { $and: [{ id_usuario: authData?.usuario?.id }] },
      });

      dispatch(setGlobalUser({ ...authData.usuario, roles: res.data }));
      dispatch(setToken(token));

      // ✅ Ahora: SOCKET CONNECT + AUTH con JWT
      if (token) {
        try {
          // 1) conecta socket (como autoConnect=false)
          if (!socket.connected) socket.connect();

          // 2) setea token al cliente feathers socket
          socketApp.authentication?.setAccessToken?.(token);

          // 3) autentica por jwt en socket
          await socketApp.authenticate({
            strategy: "jwt",
            accessToken: token,
          });

          console.log("[socket] authenticated OK");
        } catch (e) {
          console.log("[socket] auth failed", e);
          // no forzaría logout aquí; puede ser que el socket server esté caído pero REST funcione
        }
      }

      // ... catálogos como ya lo haces
      const skipCatalogServices = new Set([
        "clients",
        "product-variants",
        "product-assignments",
      ]);
      Object.values(defaultCatalogs).forEach((item) => {
        if (skipCatalogServices.has(item.name)) return;
        catalogs.initCatalogs(
          {
            name: item.name,
            service: item.name,
            data: item.data,
            lastUpdate: item.lastUpdate,
          },
          (catalog) => dispatch(updateCatalogs(catalog)),
        );
      });
      return true;
    } catch (error) {
      console.error("Error authenticating!", error);
      // tu switch de errores igual
      setState({
        ...state,
        result: null,
        loading: false,
        error: {
          /*...*/
        },
      });
      return false;
    }
  };

  function onButtonClick() {
    if (state.optionsModal) {
      setState({ ...state, result: null, optionsModal: false, loading: false });
    } else {
      let formData = {};
      Object.values(getInputs()).map((field, index) => {
        console.log("key", field.key);
        const renderField = document.getElementById(field.key);
        if (renderField.value) {
          formData[field.key.replace("Login", "")] = renderField.value;
        }
      });
      console.log("form", formData);
      if (!formData.email || !formData.password) {
        setState({
          ...state,
          result: null,
          optionsModal: false,
          loading: false,
          notification: {
            title: "¡Ups!",
            message: formData.Message || "Verifica los campos.",
          },
        });
      } else if (!state.optionsModal) {
        const body = {
          ...formData,
        };
        setState({ ...state, result: null, loading: true });
        try {
          loginService(formData);
        } catch (error) {
          if (error) {
            console.log("error", error);
            setState({
              ...state,
              result: null,
              optionsModal: false,
              loading: false,
              notification: {
                title: "¡Ups!",
                message: error || "Verifica tu conexión a internet.",
              },
            });
          } else {
            setState({
              ...state,
              result: null,
              optionsModal: false,
              loading: false,
              notification: {
                title: "¡Ups!",
                message: "Verifica tu conexión a internet.",
              },
            });
          }
        }
      }
    }
  }

  function getInputs() {
    const fields = {
      email: {
        key: "emailLogin",
        fieldid: "emailLogin",
        required: true,
        name: "E-mail",
        fullWidth: true,
        label: "E-mail",
        type: "email",
      },
      password: {
        key: "passwordLogin",
        fieldid: "passwordLogin",
        required: true,
        name: "Contraseña",
        fullWidth: true,
        label: "Contraseña",
        type: "password",
      },
    };
    return fields;
  }

  async function completeInviteRegister() {
    setInviteState((prev) => ({ ...prev, error: "", success: "" }));
    const password = `${inviteState.password || ""}`;
    const passwordConfirm = `${inviteState.passwordConfirm || ""}`;
    if (password.length < 8) {
      setInviteState((prev) => ({
        ...prev,
        error: "La contraseña debe tener al menos 8 caracteres.",
      }));
      return;
    }
    if (password !== passwordConfirm) {
      setInviteState((prev) => ({
        ...prev,
        error: "Las contraseñas no coinciden.",
      }));
      return;
    }

    setInviteState((prev) => ({ ...prev, saving: true }));
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/client-invite/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_client: inviteState.idClient,
            token: inviteState.token,
            password,
          }),
        },
      );
      const json = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(
          json?.message ||
            `No fue posible completar registro (HTTP ${response.status})`,
        );
      }

      const email = json?.email || inviteState.email;
      if (!email) throw new Error("No se recibió email para iniciar sesión.");

      setInviteState((prev) => ({
        ...prev,
        success: "Cuenta creada correctamente. Iniciando sesión...",
      }));

      const logged = await loginService({ email, password });
      if (!logged) {
        throw new Error(
          "No fue posible iniciar sesión con la cuenta recién creada.",
        );
      }

      const cleanPath = window.location.pathname || "/";
      window.history.replaceState({}, document.title, cleanPath);
      setInviteState((prev) => ({ ...prev, open: false, saving: false }));
    } catch (error) {
      setInviteState((prev) => ({
        ...prev,
        saving: false,
        error: error?.message || "No fue posible completar el registro.",
      }));
    }
  }

  function fowardSelector(result, stateEdit) {
    const state = stateEdit;
    if (result.instituciones.length > 0 && state.institution == null) {
      if (result.instituciones.length === 1) {
        state.institution = result.instituciones[0];
      }
    }
    if (state.institution != null) {
      if (state.institution.roles.length > 0 && state.rol == null) {
        if (state.institution.roles.length === 1) {
          state.rol = state.institution.roles[0];
        }
      }
      if (state.institution.agendas.length > 0 && state.agenda == null) {
        if (state.institution.agendas.length === 1) {
          state.agenda = state.institution.agendas[0];
        }
      }
    }

    if (state.institution && state.rol && state.agenda) {
      const resultFinal = {
        ...result,
        ...state,
      };
      setState({ ...state, optionsModal: false }, () => {
        props.login(resultFinal);
      });
    } else if (result.instituciones.length === 0) {
      const resultFinal = {
        ...result,
        ...state,
      };
      setState({ ...state, optionsModal: false }, () => {
        props.loginWithOutInstitution(resultFinal);
      });
    } else {
      setState({ ...state, result, optionsModal: true, loading: false });
    }
  }

  function selected(optionsSelected) {
    const result = {
      ...state.result,
      ...optionsSelected,
    };
    setState({ ...state, optionsModal: false });
    dispatch({
      type: "SET_USER",
      payload: { ...result, selected: result.paciente || null },
    });
  }
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  return (
    <Dialog
      open={open && history?.location?.pathname !== "/video-call"}
      fullScreen={!isMd || intro}
      TransitionComponent={Transition}
      transitionDuration={500}
      BackdropProps={{ style: { backgroundColor: "black" } }}
      onClose={() => {
        console.log("entro a home");
        history.push("/");
      }}
      onAnimationEnd={() => {
        if (!open) {
          console.log("entro a home");
          history.push("/");
        }
      }}
      PaperComponent={Paper}
      PaperProps={{ onKeyDown: (e) => e.keyCode === 13 && onButtonClick() }}
    >
      <DialogTitle color="primary">
        {/* {'Iniciar sesión'} */}
        <Box p={2} style={{ justifyContent: "center", display: "flex" }}>
          <img
            width={"50%"}
            style={{ filter: "drop-shadow(0px 4px 8px rgba(0,0,0,0.4))" }}
            src="assets/images-app/lukai.png"
            alt=""
          />
        </Box>
      </DialogTitle>
      {renderInputs()}
      <Dialog open={inviteState.open} fullWidth maxWidth="xs">
        <DialogTitle>Completar registro en Lukai</DialogTitle>
        <DialogContent>
          {inviteState.loading ? (
            <Typography>Validando invitación...</Typography>
          ) : (
            <Box pt={1}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <img
                  src={
                    inviteState.institutionLogo || "assets/images-app/lukai.png"
                  }
                  alt={inviteState.institutionName || "Lukai"}
                  style={{ maxHeight: 64, maxWidth: 220, objectFit: "contain" }}
                />
              </Box>
              {!!inviteState.institutionName && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 1, textAlign: "center" }}
                >
                  Invitación de: {inviteState.institutionName}
                </Typography>
              )}
              <Typography variant="body2" sx={{ mb: 1 }}>
                {inviteState.nombre
                  ? `Hola ${inviteState.nombre}, crea tu contraseña para activar tu acceso.`
                  : "Crea tu contraseña para activar tu acceso."}
              </Typography>
              {!!inviteState.email && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                  sx={{ mb: 2 }}
                >
                  Usuario: {inviteState.email}
                </Typography>
              )}
              <TextField
                fullWidth
                type="password"
                label="Contraseña"
                value={inviteState.password}
                onChange={(e) =>
                  setInviteState((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                type="password"
                label="Confirmar contraseña"
                value={inviteState.passwordConfirm}
                onChange={(e) =>
                  setInviteState((prev) => ({
                    ...prev,
                    passwordConfirm: e.target.value,
                  }))
                }
              />
              {!!inviteState.error && (
                <Typography
                  color="error"
                  variant="caption"
                  display="block"
                  sx={{ mt: 2 }}
                >
                  {inviteState.error}
                </Typography>
              )}
              {!!inviteState.success && (
                <Typography
                  color="primary"
                  variant="caption"
                  display="block"
                  sx={{ mt: 2 }}
                >
                  {inviteState.success}
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              const cleanPath = window.location.pathname || "/";
              window.history.replaceState({}, document.title, cleanPath);
              setInviteState((prev) => ({ ...prev, open: false }));
            }}
          >
            Cerrar
          </Button>
          <Button
            variant="contained"
            disabled={inviteState.loading || inviteState.saving}
            onClick={completeInviteRegister}
          >
            {inviteState.saving ? "Guardando..." : "Crear acceso"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={!!state.error}>
        <DialogTitle>{state.error?.title || ""}</DialogTitle>
        <DialogContent>{state.error?.message || ""}</DialogContent>
        <DialogActions>
          <Button onClick={() => setState({ ...state, error: null })}>
            {"Ok"}
          </Button>
        </DialogActions>
      </Dialog>
      {intro && (
        <Box
          style={{
            position: "absolute",
            width: "100%",
            top: 0,
            left: 0,
            height: "100vh",
          }}
        >
          {/* <Loading /> */}
          {/* <Zoom in={intro} style={{width: '100%', height: '100%'}}> */}
          <Lottie
            loop={false}
            onComplete={() => setIntro(false)}
            animationData={isMd ? lottieJson : lottieJsonPortlad}
            play
            style={{ height: "100%" }}
          />
          {/* </Zoom> */}
        </Box>
      )}
    </Dialog>
  );
}
Login.propTypes = {};

export default Login;
